// Analytics: GA4 + Meta Pixel — activated only when env IDs are provided.
// Set REACT_APP_GA_ID (G-XXXXXXXXXX) and/or REACT_APP_META_PIXEL_ID in frontend/.env.

const GA_ID = process.env.REACT_APP_GA_ID;
const META_ID = process.env.REACT_APP_META_PIXEL_ID;

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === "undefined") return;
  initialized = true;

  // ---- GA4 ----
  if (GA_ID) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", GA_ID, { send_page_view: false });
  }

  // ---- Meta Pixel ----
  if (META_ID) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */

    window.fbq("init", META_ID);
  }
}

export function trackPageView(path) {
  if (typeof window === "undefined") return;
  if (GA_ID && window.gtag) {
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }
  if (META_ID && window.fbq) {
    window.fbq("track", "PageView");
  }
}

/**
 * Fires a conversion event on both GA4 and Meta Pixel.
 * @param {"Lead" | "CompleteRegistration" | "Contact" | "Subscribe"} type - conversion type
 * @param {object} params - extra event params (destination, course, value, currency, ...)
 */
export function trackConversion(type, params = {}) {
  if (typeof window === "undefined") return;

  const gaEvent = {
    Lead: "generate_lead",
    CompleteRegistration: "sign_up",
    Contact: "contact",
    Subscribe: "join_group",
  }[type] || "conversion";

  if (GA_ID && window.gtag) {
    window.gtag("event", gaEvent, params);
  }
  if (META_ID && window.fbq) {
    window.fbq("track", type, params);
  }
}

export const analyticsEnabled = {
  ga: Boolean(GA_ID),
  meta: Boolean(META_ID),
};
